/******************************************************************************************
 *	Purchase Authorization Status
 *******************************************************************************************
 *
 * Mapper for purchase authorization statuses.
 *
 */
(function() {


  angular.module('rcServices.paStatus', []).service(
    'PaStatus',
    /* @ngInject */
    function(_, $translate) {
      var statuses = [];
      statuses[0] = $translate.instant('global.paStatus.pending');
      statuses[1] = $translate.instant('global.paStatus.fulfilled');
      statuses[2] = $translate.instant('global.paStatus.overdue');
      statuses[3] = $translate.instant('global.paStatus.suspended');
      statuses[4] = $translate.instant('global.paStatus.removed');
      statuses[6] = $translate.instant('global.paStatus.denied');
      statuses[7] = $translate.instant('global.paStatus.removed'); //Actually, status 7 means "Cancelling", but it seems that's how resellers want this deployed.
      statuses[5] = $translate.instant('global.paStatus.removed');
      statuses[8] = $translate.instant('global.paStatus.partiallyFulfilled');
      statuses[9] = $translate.instant('global.paStatus.unfulfilled');


      this.getTranslatedLabelByStatusId = function(status) {
        return statuses[status] || null;
      };

      this.isPending = function(status) {
        return status === 0;
      };

      this.isOverdue = function(status) {
        return status === 2;
      };

      this.isRemoved = function(status) {
        return status === 4 || status === 7;
      };

      this.isCancelling = function(status) {
        return status === 8;
      };

      this.isProcessing = function(status) {
        return status === 9;
      };

      this.getPendingDurationTranslatedLabelForStatus = function(status) {
        if (this.isProcessing(status)) {
          return $translate.instant('global.paStatus.processing');
        }
        return '-';
      };

      this.getPendingStatusId = _.constant(0);

      this.getRemovedStatusId = _.constant(4);
    }
  );
})();
